export default function DeviceGuard({ children }) {
  const isMobile = /Android|iPhone|iPad|Tablet/i.test(navigator.userAgent);

  if (isMobile) {
    return (
      <h2 style={{ padding: 40, textAlign: "center" }}>
        Vui lòng đăng nhập trên máy tính để sử dụng trang quản trị
      </h2>
    );
  }

  return children;
}